import React from 'react';
/**
 * CategoryBadge 컴포넌트 - 프로젝트 카테고리를 시각적으로 표시합니다.
 * 
 * 아토믹 디자인의 원자(Atom) 레벨 컴포넌트
 */ var CategoryBadge = function(param) {
    var category = param.category, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    // 카테고리별 스타일 클래스
    var getCategoryClass = function(category) {
        switch(category){
            case '게임':
                return 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400';
            case '앱':
                return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
            case '애니메이션':
                return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
            case '교육':
                return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
            case '아트':
                return 'bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-400';
            case '음악':
                return 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400';
            default:
                return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400';
        }
    };
    return /*#__PURE__*/ React.createElement("span", {
        className: "px-2 py-1 text-xs rounded ".concat(getCategoryClass(category), " ").concat(className)
    }, category);
};
export default CategoryBadge;
